
import React from 'react';
import DatenschutzContainer from './datenschutz/DatenschutzContainer';

const Datenschutz = () => {
  return <DatenschutzContainer />;
};

export default Datenschutz;
